'use client';
import { ReactNode } from 'react';
import cn from 'classnames';
import Slider, { Settings } from 'react-slick';

import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import './SlickCarousel.style.scss';

type SlickCarouselProps = {
  className?: string;
  /**
   * Please see this documentation to see what props you can
   * pass into this Carousel component
   * https://react-slick.neostack.com/docs/api/
   * */
  slickSettings?: Settings;
  children: ReactNode[];
};

function SlickCarousel(props: SlickCarouselProps) {
  const { className = '', children, slickSettings = {} } = props;
  return (
    <div className={cn('SlickCarousel', className)}>
      <Slider {...slickSettings}>{children}</Slider>
    </div>
  );
}

export default SlickCarousel;
